import React from 'react';
import {
    View,
    colors,
    Page,
    Grid,
    GridColumn,
    Link,
    Heading,
} from '@fairygodboss/ui';
import { ContentCard } from './components/ContentCard';
import { useCommunityContent } from '../CommunityContentContext';

export const RecentContent = () => {
    const {
        hash,
        recentContent,
        contentType,
        seeMoreLink,
    } = useCommunityContent();

    const articles = recentContent
        .filter((article) => article.hash !== hash)
        .slice(0, 6);

    return (
        <View
            display="flex"
            width="100%"
            css={{
                fontFamily: 'Open Sans',
                color: colors.neutral[100],
                'a:visited': {
                    color: `${colors.primary[60]} !important`,
                    'div > svg': {
                        path: {
                            fill: colors.primary[60],
                        },
                    },
                    'a:hover': {
                        'div > svg': {
                            path: {
                                fill: colors.primary[80],
                            },
                        },
                    },
                },
                a: {
                    textDecoration: 'none',
                    fontSize: '16px',
                    lineHeight: '20px',
                    fontWeight: '600',
                },
            }}
            backgroundColor="#F0F2F5"
        >
            <View
                display="flex"
                width="100%"
                flexDirection="column"
                alignItems="center"
            >
                <Page width="100%">
                    <Grid
                        maxWidth="1176px"
                        pl={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                        pr={{ _: '16px', sm: '8px', md: '12px', lg: '12px' }}
                        justifyContent={{
                            _: 'left',
                            sm: 'center',
                            md: 'left',
                            lg: 'right',
                        }}
                    >
                        <GridColumn
                            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                            pl="100px"
                            backgroundColor="red"
                            css={{
                                paddingLeft: '0px',
                                paddingRight: '0px',
                                position: 'relative',
                            }}
                        >
                            <Heading
                                pt={{
                                    _: '40px',
                                    sm: '32px',
                                    md: '48px',
                                    lg: '56px',
                                }}
                                variant={{ _: 'headingSm', sm: 'headingLg' }}
                                fontWeight="700"
                                mb={{ _: '8px', sm: '-8px', md: '0px' }}
                                pl={{ _: '0px', sm: '8px', md: '12px' }}
                                css={{
                                    h2: {
                                        fontWeight: '700',
                                    },
                                }}
                            >
                                <h2> Browse recent {contentType} </h2>
                            </Heading>
                            <View display="flex" flexWrap="wrap">
                                {articles.length
                                    ? articles.map((i) => {
                                          return (
                                              <ContentCard
                                                  hash={i?.hash}
                                                  key={i?.hash}
                                                  type={i?.type}
                                                  article={
                                                      i?.article || i?.podcast
                                                  }
                                                  url={i?.contentUrl}
                                              />
                                          );
                                      })
                                    : null}
                            </View>
                            <View
                                display="-webkit-box"
                                justifyContent="end"
                                py="48px"
                                pr={{ _: '0px', sm: '8px', md: '12px' }}
                            >
                                <Link
                                    href={seeMoreLink}
                                    target="_self"
                                    icon
                                    variant="standalone"
                                >
                                    See more
                                </Link>
                            </View>
                        </GridColumn>
                    </Grid>
                </Page>
            </View>
        </View>
    );
};
